import { useJunoCommonFunctions } from '../../../client/Juno/helpers';
import Modal from './FilterModal';
import FilterWrapper from './FilterWrapper';
import PropTypes from 'prop-types';

export default function MobileFilterModal({ open, onClose, filter, setFilter }) {
    const { useWindowWidth } = useJunoCommonFunctions();
    const windowWidth = useWindowWidth();

    return (
        <Modal open={open} onClose={onClose} title="FILTER" fullScreen={windowWidth < 768}>
            <FilterWrapper
                onFiltersChange={setFilter}
                initialFilters={filter}
                open={open}
                onClose={onClose}
            />
        </Modal>
    );
}

MobileFilterModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    filter: PropTypes.shape({
        currency: PropTypes.arrayOf(PropTypes.string),
        currencyType: PropTypes.arrayOf(PropTypes.string),
        type: PropTypes.arrayOf(PropTypes.string),
        from: PropTypes.string,
        to: PropTypes.string,
        status: PropTypes.arrayOf(PropTypes.string),
    }),
    setFilter: PropTypes.func.isRequired,
};

MobileFilterModal.defaultProps = {
    filter: null,
};
